import React from 'react';
import PropTypes from 'prop-types';

import { competitionClassificationList, CompetitionClassification } from '../../../typings/competition';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import './legend-item.scss';

export interface ILegendItem {
  children: React.ReactNode;
  color?: string;
  title?: string;
  tag?: string;
  separator?: string;
}

const VALID_TAGS = ['span', 'li'];
const FALLBACK_TAG = 'li';

const classNames = (color: string | undefined): IClassNames =>
  makeClassNames({
    legendItem: 'legend-item',
    color: ['legend-item__indicator', color && `legend-item__indicator${`--color-${color}`}`],
    title: 'legend-item__title',
  });

const LegendItem: React.FC<ILegendItem> = ({ color, children, tag, title, separator = ':' }) => {
  const safeTag = tag ? tag.toLowerCase() : FALLBACK_TAG;
  const Tag = VALID_TAGS.includes(safeTag) ? safeTag : FALLBACK_TAG;
  const cn = classNames(color);

  return (
    // @ts-ignore
    <Tag className={cn.legendItem}>
      {color && <span className={cn.color} />}
      {title && <div className={cn.title}>{title + separator}</div>}
      {children}
    </Tag>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  LegendItem.propTypes = {
    children: PropTypes.node.isRequired,
    color: PropTypes.oneOf<CompetitionClassification>(competitionClassificationList),
    separator: PropTypes.string,
    tag: PropTypes.string,
    title: PropTypes.string,
  };
}

export default LegendItem;
